import { cookies } from 'next/headers.js';
export const getCookies = async () => {
    return (await cookies())
        .getAll()
        .reduce((acc, { name, value }) => ({ ...acc, [name]: value }), {});
};
//# sourceMappingURL=getCookies.js.map